import Wrapper from 'components/wrapper'
import Page from 'components/page'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import { useQuery } from '@tanstack/react-query';
import api from 'services/api';
import { useHistory, useParams } from 'react-router-dom';
import { Table, TableBody, TableCell, TableContainer, IconButton, TableRow, TextField, InputAdornment, Typography, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import dayjs from 'dayjs';
import { useState } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import WrapperWithHeader from 'components/wrapper-with-header';
import Loading from 'components/loading';
import ChipStatus from 'utils/project/chip-status';
import { ChevronRight } from '@mui/icons-material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

interface IActivitiesResponse {
    processToLoadData: {
        projectId?: string,
        templateProjectId?: string,
        templateProjectRecipeId?: string,
        activityId?: string,
        activityName?: string,
        lastExecution?: null | {
            executedBy?: string,
            executedAt: string,
            status?: string,
        }
    }[],
    processToExecute: {
        activityId?: string,
        activityName: string,
        lastExecution?: null | {
            executedAt: string,
            status?: string,
        }
    }[],
    processToValidate: [],
    processToSimulate: [],
}

interface IContractResponse {
    id: string,
    name: string,
    organization: {
        corporateName: string,
    },
}

const getNextMondayAt16 = (): string => {
    const today = dayjs()
    const dayOfWeek = today.day()
    const daysUntilMonday = (8 - dayOfWeek) % 7 || 7
  
    const nextMonday = today.add(daysUntilMonday, 'day').set('hour', 16).set('minute', 0).set('second', 0)
  
    return nextMonday.format('DD/MM/YYYY')
  }

export default function PageActivities() {
    const { organizationId, contractId } = useParams() as { organizationId: string, contractId: string };
    const history = useHistory();

    const [currentFilters, setCurrentFilters] = useState({
        activityName: '',
        activityType: 'TODOS',
        activityLastExecution: null,
        // activityLastExecution: '2025-03-10T23:08:52.115Z',
    });

    function handleFilterLoad (activities: IActivitiesResponse['processToLoadData']): IActivitiesResponse['processToLoadData'] {
        return activities.filter(activity => {
            const isActivityNameFiltered = activity?.activityName?.toLocaleLowerCase()?.includes(currentFilters.activityName) ?? false;
            const isLastExecutionFiltered = !currentFilters?.activityLastExecution ? true : !activity?.lastExecution?.executedAt ? false : (dayjs(activity.lastExecution.executedAt).format('DD/MM/YYYY') === dayjs(currentFilters?.activityLastExecution).format('DD/MM/YYYY'));

            return isActivityNameFiltered && isLastExecutionFiltered;
        });  
    }

    function handleFilterExecute (activities: IActivitiesResponse['processToExecute']): IActivitiesResponse['processToExecute'] {
        return activities.filter(activity => {
            const isActivityNameFiltered = activity?.activityName?.toLocaleLowerCase()?.includes(currentFilters.activityName) ?? false;
            const isLastExecutionFiltered = !currentFilters?.activityLastExecution ? true : !activity?.lastExecution?.executedAt ? false : (dayjs(activity.lastExecution.executedAt).format('DD/MM/YYYY') === dayjs(currentFilters?.activityLastExecution).format('DD/MM/YYYY'));

            return isActivityNameFiltered && isLastExecutionFiltered;
        });  
    }

    function handleChangeFilters(filters: typeof currentFilters) {
        setCurrentFilters({ ...filters });
    };

    const shouldNotRedirect = ['773a839c-43b6-4b14-8691-cedff98d7817', '032d5221-7e51-4a59-a160-84d70a47d1eb'];


    const { data, isFetching, isFetched, isError } = useQuery({
        queryKey: ['activities', `${organizationId}`, `${contractId}`],
        queryFn: () => api.post<{ data: IActivitiesResponse, statusCode: number }>(`/projects/list-activity/${organizationId}/${contractId}`),
        select: (data) => ({
            activitiesLoad: !data?.data?.data?.processToLoadData ? [] : data.data.data.processToLoadData,
            activitiesProcess: !data?.data?.data?.processToExecute ? [] : data.data.data.processToExecute,
            activitiesValidation: !data?.data?.data?.processToValidate ? [] : data.data.data.processToValidate,
            activitiesSimulation: !data?.data?.data?.processToSimulate ? [] : data.data.data.processToSimulate,
        })
    });
    
    const { data: contract, isFetching: isContractFetching, isError: isContractError } = useQuery({
        queryKey: ['contract', `${organizationId}`, `${contractId}`],
        queryFn: () => api.get<{ data: IContractResponse, statusCode: number }>(`/contracts/${contractId}`)
    });

    console.log("barbaridade", data?.activitiesLoad, dayjs(currentFilters?.activityLastExecution).format('DD/MM/YYYY'))

    if (isContractFetching || !contract) {
        return (
            <WrapperWithHeader>
                <Loading />
            </WrapperWithHeader>
        )
    }

  return (
    <Wrapper>
        <Header>
            <HeaderModule.title
                text={`${contract?.data?.data?.id.split("-")[0].toUpperCase()} - ${contract?.data?.data?.organization?.corporateName} - ${contract?.data?.data?.name}`}
                backRoute={`/contract/${organizationId}`}
            />
                <HeaderModule.tabs
                current={0}
                options={['Atividades', 'Histórico', 'Contrato']}
                onChange={() => {}}
                moduleName='activities view'
                />
        </Header>
        {isFetching && (
            <div>Loading...</div>
        )}
        {isError && (
            <div>Something went wrong...</div>
        )}
        {isFetched && data && (
            <Page>
                <div style={{ width: '100%', padding: '24px', backgroundColor: 'white', display: 'flex', flexDirection: 'column', gap: '25px', borderRadius: '8px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h1 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600,marginBottom: '24px'}}>Selecione uma atividade</h1>
                    </div>

                    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '10px' }}>
                        <TextField
                            fullWidth
                            label='Nome da atividade'
                            placeholder='Digite para pesquisar'
                            variant='outlined'
                            value={currentFilters.activityName}
                            onChange={(e) => handleChangeFilters({ ...currentFilters, activityName: e.target.value })}
                            InputProps={{ 
                                startAdornment: (
                                    <InputAdornment position='start'>
                                        <SearchIcon color='action' style={{ width: '24px', aspectRatio: '1' }}/>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center', marginBottom: '24px' }}>
                            <Typography color='gray' variant='body2'>Filtrar por</Typography>
                            <FormControl style={{ width: '250px' }}>
                                <InputLabel id="tipo_atividade">Tipo de atividade</InputLabel>
                                <Select
                                    labelId="tipo_atividade"
                                    value={currentFilters.activityType}
                                    onChange={(e) => handleChangeFilters({ ...currentFilters, activityType: e.target.value })}
                                    style={{ height: '55.3px', marginBottom: '2.7px' }}
                                >
                                    <MenuItem value={'LOAD_DATA'}>Preparar Dados</MenuItem>
                                    <MenuItem value={'EXECUTE_PROCESS'}>Executar processo</MenuItem>
                                    <MenuItem value={'VALIDATION'}>Validação</MenuItem>
                                    <MenuItem value={'SIMULATION'}>Simulação</MenuItem>
                                    <MenuItem value={'TODOS'}>Todos</MenuItem>
                                </Select>
                            </FormControl>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Última atualização"
                                    format="DD / MM / YYYY"
                                    value={currentFilters.activityLastExecution}
                                    onChange={(e) => handleChangeFilters({ ...currentFilters, activityLastExecution: e })}
                                    slotProps={{ textField: { style: { maxWidth: '260px' } }}}
                                />
                            </LocalizationProvider>
                            <Button 
                                onClick={() => handleChangeFilters({ activityType: 'TODOS', activityName: '', activityLastExecution: null })}
                            >Limpar filtro</Button>
                        </div>
                    </div>

                    {(currentFilters.activityType === 'TODOS' || currentFilters.activityType === 'LOAD_DATA') && (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ backgroundColor: '#EDEDED', borderRadius: '100px', width: 'fit-content', padding: '6px 9px 6px 9px' }}>
                                <span style={{ fontSize: '13px', fontWeight: '400' }}>Preparar Dados</span> 
                            </div>
                            <TableContainer sx={{ "& .MuiTableCell-root": { background: "#FFFFFF !important" } }}>
                                <Table>
                                    <TableRow style={{ height: '70px'}}>
                                        <TableCell style={{ width: '350px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Nome
                                            </span>
                                        </TableCell>
                                        <TableCell style={{ width: '300px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Última atualização
                                            </span>
                                        </TableCell>
                                        <TableCell style={{ width: '300px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Execução programada
                                            </span>
                                        </TableCell>
                                        <TableCell style={{ width: '300px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Status
                                            </span>
                                        </TableCell>
                                        <TableCell>{` `}</TableCell>
                                    </TableRow>
                                    {handleFilterLoad(data.activitiesLoad).map(activity => (
                                        <TableRow key={activity.activityId} style={{ height: '70px'}}>
                                            <TableCell>{activity.activityName}</TableCell>
                                            <TableCell>{activity?.lastExecution?.executedAt ? dayjs(activity?.lastExecution?.executedAt).format('DD/MM/YYYY') : '-'}</TableCell>
                                            <TableCell>{activity?.activityId === '773a839c-43b6-4b14-8691-cedff98d7817' ? getNextMondayAt16() : '-'}</TableCell>
                                            <TableCell>
                                                {!activity?.lastExecution?.status ? (
                                                    '-'
                                                ) : activity.lastExecution?.status === 'success' ? (
                                                    <div style={{ color: '#2E7D32', backgroundColor: '#2E7D3214', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                        <span>Executado</span>
                                                    </div>
                                                ) : (
                                                    <div style={{ color: '#191C1A', backgroundColor: '#191C1A14', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                        <span>Aguardando</span>
                                                    </div>
                                                )}
                                            </TableCell>
                                            {!shouldNotRedirect.includes(activity?.activityId ?? '') ? (
                                                <TableCell 
                                                    onClick={() => history.push(`/projects/activities/${activity?.projectId}/app/${activity.templateProjectRecipeId}/${organizationId}/${contractId}/${activity.templateProjectRecipeId}`)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <IconButton size="small">
                                                        <ChevronRight />
                                                    </IconButton>
                                                </TableCell>
                                            ) : (
                                                <TableCell>{` `}</TableCell>
                                            )}
                                        </TableRow>
                                    ))}
                                </Table>
                            </TableContainer>
                        </div>
                    )}

                    {(currentFilters.activityType === 'TODOS' || currentFilters.activityType === 'EXECUTE_PROCESS') && (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ backgroundColor: '#EDEDED', borderRadius: '100px', width: 'fit-content', padding: '6px 9px 6px 9px' }}>
                                <span style={{ fontSize: '13px', fontWeight: '400' }}>Executar processos</span> 
                            </div>
                            <TableContainer sx={{ "& .MuiTableCell-root": { background: "#FFFFFF !important" } }}>
                                <Table>
                                    <TableRow style={{ height: '70px'}}>
                                        <TableCell style={{ width: '350px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Nome
                                            </span>
                                        </TableCell>
                                        <TableCell style={{ width: '300px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Última atualização
                                            </span>
                                        </TableCell>
                                        <TableCell style={{ width: '300px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Execução programada
                                            </span>
                                        </TableCell>
                                        <TableCell style={{ width: '300px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Status
                                            </span>
                                        </TableCell>
                                        <TableCell>{` `}</TableCell>
                                    </TableRow>
                                    {handleFilterExecute(data.activitiesProcess).map(activity => (
                                        <TableRow key={activity.activityId} style={{ height: '70px'}}>
                                            <TableCell>{activity.activityName}</TableCell>
                                            <TableCell>{activity?.lastExecution?.executedAt ? dayjs(activity?.lastExecution?.executedAt).format('DD/MM/YYYY') : '-'}</TableCell>
                                            <TableCell>{'-'}</TableCell>
                                            <TableCell>
                                                {!activity?.lastExecution?.status ? (
                                                    '-'
                                                ) : activity.lastExecution?.status === 'success' ? (
                                                    <div style={{ color: '#2E7D32', backgroundColor: '#2E7D3214', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                        <span>Executado</span>
                                                    </div>
                                                ) : (
                                                    <div style={{ color: '#191C1A', backgroundColor: '#191C1A14', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                        <span>Aguardando</span>
                                                    </div>
                                                )}
                                            </TableCell>
                                            <TableCell 
                                                onClick={() => {
                                                    if (activity.activityName === 'Movimentação') history.push(`/contract/movimentacao/${organizationId}/${contractId}/${activity.activityId}`);
                                                    if (activity.activityName === 'Implantação') history.push(`/contract/${organizationId}/${contractId}/${activity.activityId}`);
                                                }} 
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <IconButton size="small">
                                                    <ChevronRight />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </Table>
                            </TableContainer>
                        </div>
                    )}

                    {(currentFilters.activityType === 'TODOS' || currentFilters.activityType === 'VALIDATION') && (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ backgroundColor: '#EDEDED', borderRadius: '100px', width: 'fit-content', padding: '6px 9px 6px 9px' }}>
                                <span style={{ fontSize: '13px', fontWeight: '400' }}>Validação</span> 
                            </div>
                            <TableContainer sx={{ "& .MuiTableCell-root": { background: "#FFFFFF !important" } }}>
                                <Table>
                                    <TableRow style={{ height: '70px'}}>
                                        <TableCell style={{ width: '350px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Nome
                                            </span>
                                        </TableCell>
                                        <TableCell style={{ width: '300px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Última atualização
                                            </span>
                                        </TableCell>
                                        <TableCell style={{ width: '300px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Execução programada
                                            </span>
                                        </TableCell>
                                        <TableCell style={{ width: '300px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Status
                                            </span>
                                        </TableCell>
                                        <TableCell>{` `}</TableCell>
                                    </TableRow>
                                    {handleFilterLoad(data.activitiesValidation).map(activity => (
                                        <TableRow key={activity.activityId} style={{ height: '70px'}}>
                                            <TableCell>{activity.activityName}</TableCell>
                                            <TableCell>{activity?.lastExecution?.executedAt ? dayjs(activity?.lastExecution?.executedAt).format('DD/MM/YYYY') : '-'}</TableCell>
                                            <TableCell>{'-'}</TableCell>
                                            <TableCell>
                                                {!activity?.lastExecution?.status ? (
                                                    '-'
                                                ) : activity.lastExecution?.status === 'success' ? (
                                                    <div style={{ color: '#2E7D32', backgroundColor: '#2E7D3214', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                        <span>Executado</span>
                                                    </div>
                                                ) : (
                                                    <div style={{ color: '#191C1A', backgroundColor: '#191C1A14', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                        <span>Aguardando</span>
                                                    </div>
                                                )}
                                            </TableCell>
                                            {!shouldNotRedirect.includes(activity?.activityId ?? '') ? (
                                                <TableCell 
                                                    onClick={() => history.push(`/projects/activities/${activity?.projectId}/app/${activity.templateProjectRecipeId}/${organizationId}/${contractId}/${activity.templateProjectRecipeId}`)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <IconButton size="small">
                                                        <ChevronRight />
                                                    </IconButton>
                                                </TableCell>
                                            ) : (
                                                <TableCell>{` `}</TableCell>
                                            )}
                                        </TableRow>
                                    ))}
                                </Table>
                            </TableContainer>
                        </div>    
                    )}
                    
                    {(currentFilters.activityType === 'TODOS' || currentFilters.activityType === 'SIMULATION') && (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ backgroundColor: '#EDEDED', borderRadius: '100px', width: 'fit-content', padding: '6px 9px 6px 9px' }}>
                                <span style={{ fontSize: '13px', fontWeight: '400' }}>Simulação</span> 
                            </div>
                            <TableContainer sx={{ "& .MuiTableCell-root": { background: "#FFFFFF !important" } }}>
                                <Table>
                                    <TableRow style={{ height: '70px'}}>
                                        <TableCell style={{ width: '350px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Nome
                                            </span>
                                        </TableCell>
                                        <TableCell style={{ width: '300px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Última atualização
                                            </span>
                                        </TableCell>
                                        <TableCell style={{ width: '300px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Execução programada
                                            </span>
                                        </TableCell>
                                        <TableCell style={{ width: '300px' }}>
                                            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                                                Status
                                            </span>
                                        </TableCell>
                                        <TableCell>{` `}</TableCell>
                                    </TableRow>
                                    {handleFilterLoad(data.activitiesSimulation).map(activity => (
                                        <TableRow key={activity.activityId} style={{ height: '70px'}}>
                                            <TableCell>{activity.activityName}</TableCell>
                                            <TableCell>{activity?.lastExecution?.executedAt ? dayjs(activity?.lastExecution?.executedAt).format('DD/MM/YYYY') : '-'}</TableCell>
                                            <TableCell>{'-'}</TableCell>
                                            <TableCell>
                                                {!activity?.lastExecution?.status ? (
                                                    '-'
                                                ) : activity.lastExecution?.status === 'success' ? (
                                                    <div style={{ color: '#2E7D32', backgroundColor: '#2E7D3214', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                        <span>Executado</span>
                                                    </div>
                                                ) : (
                                                    <div style={{ color: '#191C1A', backgroundColor: '#191C1A14', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                        <span>Aguardando</span>
                                                    </div>
                                                )}
                                            </TableCell>
                                            {!shouldNotRedirect.includes(activity?.activityId ?? '') ? (
                                                <TableCell 
                                                    onClick={() => history.push(`/projects/activities/${activity?.projectId}/app/${activity.templateProjectRecipeId}/${organizationId}/${contractId}/${activity.templateProjectRecipeId}`)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <IconButton size="small">
                                                        <ChevronRight />
                                                    </IconButton>
                                                </TableCell>
                                            ) : (
                                                <TableCell>{` `}</TableCell>
                                            )}
                                        </TableRow>
                                    ))}
                                </Table>
                            </TableContainer>
                        </div>
                    )}
                </div>
            </Page>
        )}
    </Wrapper>
  )
}
